<template>
    <Header />
    <Transition>
        <main class="opui-main opui-pt-6">
            <div class="opui-container" v-if="loaded && collection">
                <div class="optpl-details-container">
                    <a href="#" @click.prevent="$router.go(-1)" class="optpl-back"><i class="opui-fa opui-fa-arrow-left"></i> Go back</a>

                    <div class="optpl-details-card">
                        <div class="optpl-details-card__info">
                            <div class="optpl-details-card__collections"><span>Collection</span></div>
                            <h2>{{ collection.title }}</h2>
                            <p>{{ collection.description || '-' }}</p>

                            <!-- <p><small>{{ collection.tier_ids }}</small></p> -->

                            <div class="optpl-details-card__tags-container">
                                <div class="optpl-details-card__tags" v-for="tagGroup in collection.tags">
                                    <h3>{{ tagGroup.title }}</h3>
                                    <span v-for="tag in tagGroup.tags">{{ tag.title }}</span>
                                </div>
                            </div>

                            <div class="optpl-details-card__actions">
                                <UpgradeButton v-if="!userHasTiers(collection.tier_ids)" />
                            </div>
                        </div>

                        <div class="optpl-details-card__media" v-if="collection.preview">
                            <figure><img :src="collection.preview" alt="" /></figure>
                        </div>
                    </div>

                    <div class="optpl-details-related">
                        <div class="optpl-templates__container">
                            <div class="optpl-templates__group">
                                <RelatedTemplates :group="relatedTemplates" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <DetailsAreLoading v-if="!loaded" />
        </main>
    </Transition>
</template>

<script>
import { useFiltersStore } from '../store/filters'
import { useTemplatesStore } from '../store/templates'
import { mapStores } from 'pinia'
import CreateNewPageModal from '../components/Templates/Modals/CreateNewPageModal.vue'
import Header from '../components/Global/Header.vue'
import Hero from '../components/Templates/Hero.vue'
import Filters from '../components/Templates/Filters.vue'
import RelatedTemplates from '../components/Templates/RelatedTemplates.vue'
import TemplateItem from '../components/Templates/TemplateItem.vue'
import Templates from '../components/Templates/Templates.vue'
import TemplateGroup from '../components/Templates/TemplateGroup.vue'
import UpgradeButton from '../components/Templates/UpgradeButton.vue'
import DetailsAreLoading from '../components/Loading/DetailsAreLoading.vue'

export default {
    components: { CreateNewPageModal, DetailsAreLoading, Header, Hero, Filters, RelatedTemplates, TemplateGroup, TemplateItem, Templates, UpgradeButton },
    computed: {
        ...mapStores(useFiltersStore, useTemplatesStore),
    },
    data() {
        return {
            filtersStore: useFiltersStore(),
            templatesStore: useTemplatesStore(),
            relatedTemplates: {},
            collectionUid: this.$route.params.uid,
            collection: null,
            loaded: false,
        }
    },
    created() {
        this.loadInitialData()
    },
    mounted() {
        setTimeout(() => {
            window.scrollTo({ top: 0, behavior: 'instant' })
        }, 10)
    },
    methods: {
        loadInitialData() {
            this.$http
                .get('/templates/collections/' + this.collectionUid)
                .then(async response => {
                    // console.log("COL: ", response.data);
                    this.collection = response.data.data

                    if (this.collection.templates) {
                        this.relatedTemplates = {
                            title: 'Templates In This Collection',
                            items: this.collection.templates,
                        }
                    } else {
                        this.relatedTemplates = {}
                    }

                    this.loaded = true
                })
                .catch(error => {
                    this.$toast.error('Error when fetching collection.')
                    console.error(error)
                    this.loaded = true
                })
        },
    },
}
</script>
